module.exports = __webpack_public_path__ + "src/assets/img/16.5604202f.svg";